import { useEffect } from 'react';
import { useSubNav } from '../contexts/SubNavContext';

export default function Main() {
    const { setSubNav } = useSubNav();

    useEffect(() => {
        // 메인 페이지에서는 서브 네비게이션 제거
        setSubNav(null);
    }, [setSubNav]);

    return (
        <div className="container index">
            <div className="main_tit wrap_cont">
                <h1>
                    기술로 <br />오늘의 일상과 미래를<br /> 표현합니다
                </h1>
            </div>
        </div>
    );
}
